interface FieldConfig {
  apiFieldName: string;
  alwaysArray?: boolean;
}

export function buildApiPayload<T extends Record<string, any>>(
  baseParams: T,
  fieldMappings: Record<string, FieldConfig & { values: string[] }>,
): T & Record<string, number | number[]> {
  const payload: any = { ...baseParams };

  Object.entries(fieldMappings).forEach(([, config]) => {
    const { values, apiFieldName, alwaysArray = false } = config;

    if (values.length > 0) {
      const numericValues = values.map(v => Number(v));

      if (alwaysArray) {
        payload[apiFieldName] = numericValues;
      } else {
        payload[apiFieldName] = numericValues.length === 1 ? numericValues[0] : numericValues;
      }
    }
  });

  return payload as T & Record<string, number | number[]>;
}
